(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["susies-advertorial-7-reasons"] && !Shopify.designMode) return;
  try {
    
/* Rolling countdown. Anchored to the next midnight so every visitor sees a live
   clock without a server value, and it never renders a finished 00:00:00. */
(function () {
  var els = document.querySelectorAll('[data-adv-clock]');
  if (!els.length) return;
  function tick() {
    var now = new Date();
    var end = new Date(now); end.setHours(24, 0, 0, 0);
    var left = Math.max(0, Math.floor((end - now) / 1000));
    var h = String(Math.floor(left / 3600)).padStart(2, '0');
    var m = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
    var s = String(left % 60).padStart(2, '0');
    els.forEach(function (el) {
      var H = el.querySelector('[data-h]'), M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
      if (H) H.textContent = h;
      if (M) M.textContent = m;
      if (S) S.textContent = s;
    });
  }
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
